<template>
  <div v-if="data.channel">
    <monitor-video
      :icon-color="color"
      :urls="get_urls"
      :show-player="load_player"
      @close="close"
      :edit="true"
      edit-text="Edit channel"
      @edit="open_editor"
    >
      <template v-slot:title>
        <channel-title :channel="data.channel" :alternative="data.alternative"></channel-title>
      </template>
      <template v-slot:subtitle>
        {{data.state}}
      </template>
    </monitor-video>
  </div>
</template>

<script>
import ChannelModel from '@/models/channel.js';
import ChannelTitle from '@/components/ChannelTitle.vue';
import MonitorVideo from '@/components/MonitorVideo.vue';

export default {
  props: ['data', 'developer'],
  data() {
    return {
    } 
  },
  components: {
    ChannelTitle,
    MonitorVideo
  },
  computed: {
    get_urls () {
      return [{
        title: "Monitor",
        url: this.data.url
      }];
    },
    load_player () {
      return this.data.url && this.data.state == "connected";
    },
    color () {
      if (this.data.state == "listening") return "primary";
      if (this.data.state == "disconnected") return "danger";
      if (this.data.state == "connecting") return "warning"
      if (this.data.state == "connected") return "success";
      return undefined;
    },
  },
  methods: {
    open_editor() {
      this.$router.push("/monitor/channel/"+this.data.channel.uuid)
    },
    close() {
      if (!this.$store.state.account) return;
      var acc = _.cloneDeep(this.$store.state.account);
      acc.meta.monitor_channel_filter = _.xor(acc.meta.monitor_channel_filter, [this.data.key]);
      this.$store.dispatch("update_profile", acc);
    }
  }
}
</script>
